const ACTIVE_SUBSCRIPTION_STATUSES = ["ACTIVE", "APPROVAL_PENDING"];

export function hasPlatformAccess(user) {
  if (!user) return false;
  if (user.isSponsored) return true;
  return ACTIVE_SUBSCRIPTION_STATUSES.includes(user.subscription?.status);
}
